import { Button } from "@/components/ui/button";
import { CopyIcon } from "@radix-ui/react-icons";

export const CopyButton = ({
  action,
  size,
}: {
  action: () => void;
  size?: string;
}) => {
  return (
    <Button
      type="button"
      className={`border border-zinc-200 text-zinc-950 rounded-md shadow-sm cursor-pointer ${size ? size : "w-[36px] h-[36px]"} p-0 flex items-center justify-center bg-white hover:bg-zinc-100`}
      onClick={action}
    >
      <CopyIcon />
    </Button>
  );
};
